<template>
  <div id="order_complete">
    <call />
    <pop-alert />
    <!-- header -->
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main v-if="dataReady">
      <!-- menu detail -->
      <!-- order -->
      <section v-if="hasError">
        <div class="l-order">
          <div class="l-order__info">
            <div class="l-order__title mb-16">
              大変申し訳ございません。
              <br />
              一部の注文でエラーが発生しました。
            </div>
          </div>
          <template v-for="(order, index) in orders">
            <div :class="{'c-box-time-head':true, 'mt-16': index > 0}" :key="`head_${index}`">
              <div class="c-box-time-head__title" v-if="order.status != 'ORDER_FAILED'">完了済み</div>
            </div>
            <div
              class="c-box-time-order c-box-time-order-multiple-store pl-16 pr-16"
              :key="`body_${index}`">
              <div class="c-box-time-order__head">
                <div class="c-box-time-order__head--icon">
                  <img :src="getImgSrc(order.provider && order.provider.image && order.provider.image[0])" alt="" />
                </div>
                <div class="c-box-time-order__head--title">{{order.provider.shopName}}</div>
              </div>
              <div class="c-box-time-order__median"></div>
              <div class="c-calc-price p-0 w-100 pt-12">
                <ul>
                  <li>
                    <div>合計<small>（税込）</small></div>
                    <div>{{priceFormat(order.totalAmount)}}円</div>
                  </li>
                </ul>
              </div>
            </div>
          </template>
          <template v-for="(order, index) in error_orders">
            <div :class="{'c-box-time-head':true, 'mt-16': index > 0}" :key="`head_error_${index}`">
              <div class="c-box-time-head__icon">
                <img src="/assets/images/icon/icon-warning.svg" alt="" />
              </div>
              <div class="c-box-time-head__title">{{order.tenantError && order.tenantError.message}}</div>
            </div>
            <div
              class="c-box-time-order c-box-time-order-multiple-store pl-16 pr-16"
              :key="`error_body_${index}`">
              <div class="c-box-time-order__head">
                <div class="c-box-time-order__head--icon">
                  <img :src="getImgSrc(getTenantImage(order.tenantId))" alt="" />
                </div>
                <div class="c-box-time-order__head--title">{{getTenantName(order.tenantId)}}</div>
              </div>
              <div class="c-box-time-order__median"></div>
              <div class="c-calc-price p-0 w-100 pt-12">
                <ul>
                  <li>
                    <div>合計<small>（税込）</small></div>
                    <div>{{priceFormat(order.totalAmount)}}円</div>
                  </li>
                </ul>
              </div>
            </div>
          </template>

          <div class="c-btn c-btn--red box-center mt-16" @click.prevent="reorderErrors()">
                エラーになった注文を再注文する
          </div>
          <div class="c-btn c-btn--red box-center mt-8" @click.prevent="cancelErrros()">
                完了済みの商品のみ受け取る
          </div>
          <div class="l-order__link mt-32 mb-16">
            <a href="javascript:void(0)" @click.prevent="cancelAllOrders()">全ての注文をキャンセルする</a>
          </div>
        </div>
      </section>
      <section v-else>
        <div class="l-order">
          <div class="l-order__info">
            <div class="l-order__title">
              <div class="mb-20">{{orders[0].orderType == 3 ? 'ご予約' : 'ご注文'}}が完了いたしました。</div>
              {{orders[0].orderType == 3 ? 'ご予約' : 'ご注文'}}内容は、モバイルオーダーTOP画面の「注文状況・履歴」より、ご確認いただけます。
            </div>
            <img class="mb-28" src="/assets/images/order_complete_info.png" alt="" style="margin: 0 20px;">
            <div class="l-order__link mb-32">
              <router-link to="/mobileorder/history">ご注文状況・履歴はこちら</router-link>
            </div>
            <div class="c-order-tutorial mb-16 box-center">
              <div class="c-order-tutorial__item">
                <div class="c-order-tutorial__number">1</div>
                <div class="c-order-tutorial__content">
                  店舗の確認が完了すると、ステータスが「{{orders[0].orderType == 3 ? 'ご予約確定' : '店舗準備中'}}」に変わります。
                </div>
              </div>
              <div class="c-order-tutorial__item" v-if="orders[0].orderType != 3">
                <div class="c-order-tutorial__number">2</div>
                <div class="c-order-tutorial__content">
                  準備が完了しましたら、ショップからお知らせの通知がアプリに届きますので、そちらをご確認ください。
                </div>
              </div>
            </div>
            <div class="c-order-note box-center">
              <template  v-if="orders[0].orderType != 3">
                ※お受け取りの目安時間はあくまで目安となりますので、店舗からのお知らせ通知をお待ちください。<br /><br />
              </template>


              ※緊急の場合、店舗からアプリに音声通話でご連絡する場合があります。<br /><br />
              ＜キャンセルについて＞ <br />
              ステータスが{{orders[0].orderType == 3 ? 'ご予約完了' : '店舗確認中'}}の場合は、アプリから注文をキャンセルすることができます。{{orders[0].orderType == 3 ? 'ご予約確定' : '店舗準備中'}}になりましたら、それ以降アプリからのキャンセルはできません。直接店舗へお問い合わせください。<br /><br />
              ※ステータスに「{{orders[0].orderType == 3 ? 'ご予約完了' : '店舗確認中'}}」と表示されている場合でも、通信等の状況によりキャンセルを承れない場合がございます。予めご了承ください。
            </div>
          </div>
        </div>
      </section>
       <alert :message="alert_msg" 
      :show="alert_show" 
      :closeModal="closeModal" 
      :confirm_show="confirm_show" 
      :confirm_message="confirm_msg" 
      :confirm_callback="confirm_callback" 
      :confirm_hide_cancel="confirm_hide_cancel"
      :label_cancel="confirm_label_cancel"
      :label_ok="confirm_label_ok"
      ></alert>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Menu from "../components/Menu.vue";
import Alert from "../components/Alert.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import firebase from "../common/firebaseProject";
import { getProviderByShopCategory, getOrdersByGroupId } from "../store/firestore";
import PopAlert from "../components/PopAlert.vue";

export default Vue.extend({
  name: "MobileOrderComplete",
  components: {
    'header-app': Header,
    'menu-app': Menu,
    'alert': Alert,
    PopAlert
  },
  mixins: [Tenant],
  async created(){ 
    const cartData = this.$store.state.cart;
    const orderGroupId = this.$route.params.orderGroupId;
    const userId = this.$store.state.userId;
    const orders = await getOrdersByGroupId(userId, orderGroupId);
    this.orders = orders.filter(item => item.status != 'ORDER_FAILED');
    const order_errors_backend = orders.filter(item => item.status == 'ORDER_FAILED');
    const error_orders = Object.values(cartData);
    this.error_orders = error_orders;
    this.hasError = error_orders.length > 0;
    this.dataReady = true;
    const result = await getProviderByShopCategory(0)
    this.tenants = result;
  },
  data(){
    return {
      dataReady: false,
      orders: undefined,
      hasError: false,
      tenants: []
    }
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    getTenant(tenantId) {
      if(this.tenants.length) {
        return this.tenants.find(item => item.id == tenantId);
      }
      return undefined;
    },
    getTenantName(tenantId) {
      const tenant = this.getTenant(tenantId);
      if (tenant) {
        return tenant.shopName;
      }
    },
    getTenantImage(tenantId) {
      const provider = this.getTenant(tenantId);
      return provider && provider.image && provider.image[0]
    },
    async cancelAllOrders() {
      const promises = [];
      const idToken = await this.getIdToken();
      if (!idToken) return;
      this.orders.forEach(order => {
        const f = async () => {
          const callable = firebase.functions('asia-northeast1').httpsCallable('cancel');
          const data = {
            tenantId: order.tenantId,
            orderId: order.id,
            iid: this.$store.state.installId
          }
          const result = await callable(data)
          .catch(e => {
            throw e;
          })
        }
        promises.push(f());
      })
      await Promise.allSettled(promises)
      .then(results => {
        const rejected = results.filter(item => item.status == "rejected");
        if (rejected.length > 0) {
          this.alert("一部ご注文でキャンセルを承れなかったものがありました。ご注文状況・履歴よりご確認ください。");
        }
      })
    },
    cancelErrors() {
      this.$store.dispatch('clearCart');
      this.$router.push('/mobileorder/history');
    },
    reorderErrors() {
      this.$router.push('/mobileorder/cart');
    }
  }
});
</script>